import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { IClassroomReq } from '../../../models/classrooms.model';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/campus/classroom/Editor';
import useAxios from '../../../hooks/useAxios';
import {
  deleteClassroom,
  getClassroom,
  updateClassroom,
} from '../../../api/classrooms.api';
import ErrorResponse from '../../../components/ErrorResponse';
import useNotification from '../../../hooks/useNotification';

interface IMatch {
  id: string;
}

const CampusClassroomEdit: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  const {
    data: classroom,
    isLoading: getIsLoading,
    error: getError,
  } = useAxios(getClassroom(id));
  const {
    data: updateData,
    isLoading: updateIsLoading,
    error: updateError,
    execute: updateExecute,
  } = useAxios();
  const {
    data: deleteData,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();
  const { successNotification } = useNotification();

  const onSubmit = async (req: IClassroomReq) => {
    await updateExecute(updateClassroom(id, req));
  };

  const onDelete = async () => {
    await deleteExecute(deleteClassroom(id));
  };

  useEffect(() => {
    if (deleteData && !deleteIsLoading) {
      successNotification(t('common.message.delete'));
      history.push(`/campus/classroom${location.search}`);
    }
  }, [deleteData, deleteIsLoading]);

  useEffect(() => {
    if (updateData && !updateIsLoading) {
      successNotification(t('common.message.edit'));
      history.push(`/campus/classroom${location.search}`);
    }
  }, [updateData, updateIsLoading]);

  return (
    <div className="content scrollbar">
      {getIsLoading || updateIsLoading || deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={getError || updateError || deleteError} />
      <SimpleHeader parentMenu={t('common.menu.campus')} currentMenu={t('campus.classroom.title2')} />
      <Editor
        classroom={classroom?.data || null}
        onSubmit={onSubmit}
        onDelete={onDelete}
      />
    </div>
  );
};

export default CampusClassroomEdit;
